import UserPermission from './UserPermission'

export default UserPermission
